import { render, staticRenderFns } from "./AuditLogTable.vue?vue&type=template&id=4f36b0f6&scoped=true&"
import script from "./AuditLogTable.vue?vue&type=script&lang=js&"
export * from "./AuditLogTable.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogTable.vue?vue&type=style&index=0&id=4f36b0f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f36b0f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VChip,VDivider,VExpandTransition,VProgressCircular,VSimpleTable})
